import { useChainId } from 'wagmi'

import { getChainConfigEntry } from '@/config/chain'
import { ChainConfigEntry } from '@/config/chain/types'

export function useChainConfigEntry(): ChainConfigEntry {
  const chainId = useChainId()
  return getChainConfigEntry(chainId)
}
